import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "leftRight",
  "use": "leftRight-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" viewBox=\"0 0 16 16\" id=\"leftRight\"><path d=\"M4.667 15.333L2 12.667 4.667 10m6.666 2.667H2m9.333-12L14 3.333 11.333 6M4.667 3.333H14\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol